import { render, staticRenderFns } from "./notification-ActivityAssigned.vue?vue&type=template&id=35aa5faa&scoped=true"
import script from "./notification-ActivityAssigned.vue?vue&type=script&lang=js"
export * from "./notification-ActivityAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35aa5faa",
  null
  
)

export default component.exports